export const TOTAL_FORMS = /** @type {const} */ ([
  {
    Id: 7529,
    Id_ModuloRaiz: 0,
    Nombre: 'Control de Producción',
    FechaActivacion: '2022-04-20T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [
      {
        Id: 7540,
        Id_ModuloRaiz: 7529,
        Nombre: 'Paletizado',
        FechaActivacion: '2022-08-04T00:00:00',
        FechaDesactivacion: '1900-01-01T00:00:00',
        SubModulos: [],
        Procesos: [
          {
            Id: 6626,
            Id_Modulo: 7540,
            Id_Tareas: 4406,
            Nombre: 'Paletizado múltiple',
            Operaciones: [
              {
                Id: 11543,
                Id_Tareas: 4406,
                Codigo: '9417',
                Nombre: 'Consultar Paletizado múltiple',
              },
              {
                Id: 11544,
                Id_Tareas: 4406,
                Codigo: '9418',
                Nombre: 'Modificar Paletizado múltiple',
              },
              {
                Id: 11545,
                Id_Tareas: 4406,
                Codigo: '9419',
                Nombre: 'Eliminar Paletizado múltiple',
              },
              {
                Id: 11546,
                Id_Tareas: 4406,
                Codigo: '9420',
                Nombre: 'Crear Paletizado múltiple',
              },
            ],
            Formulario: '/production/traceability/palletizing/FrmMultipointPalletizing',
            Ensamblado: '',
          },
          {
            Id: 7633,
            Id_Modulo: 7540,
            Id_Tareas: 4408,
            Nombre: 'Paletizado',
            Operaciones: [
              {
                Id: 11551,
                Id_Tareas: 4408,
                Codigo: '9425',
                Nombre: 'Consultar Paletizado',
              },
              {
                Id: 11552,
                Id_Tareas: 4408,
                Codigo: '9426',
                Nombre: 'Modificar Paletizado',
              },
              {
                Id: 11553,
                Id_Tareas: 4408,
                Codigo: '9427',
                Nombre: 'Eliminar Paletizado',
              },
              {
                Id: 11554,
                Id_Tareas: 4408,
                Codigo: '9428',
                Nombre: 'Crear Paletizado',
              },
            ],
            Formulario: '/production/traceability/palletizing/FrmPalletizingHome',
            Ensamblado: '',
          },
          {
            Id: 7636,
            Id_Modulo: 7540,
            Id_Tareas: 4416,
            Nombre: 'Picking',
            Operaciones: [
              {
                Id: 11583,
                Id_Tareas: 4416,
                Codigo: '9457',
                Nombre: 'Consultar Picking',
              },
              {
                Id: 11584,
                Id_Tareas: 4416,
                Codigo: '9458',
                Nombre: 'Modificar Picking',
              },
              {
                Id: 11585,
                Id_Tareas: 4416,
                Codigo: '9459',
                Nombre: 'Eliminar Picking',
              },
              {
                Id: 11586,
                Id_Tareas: 4416,
                Codigo: '9460',
                Nombre: 'Crear Picking',
              },
            ],
            Formulario: '/production/commercialization/picking/FrmPicking',
            Ensamblado: '',
          },
          {
            Id: 9799,
            Id_Modulo: 7540,
            Id_Tareas: 4541,
            Nombre: 'Pesaje de palés',
            Operaciones: [
              {
                Id: 12062,
                Id_Tareas: 4541,
                Codigo: '9908',
                Nombre: 'Consultar Pesaje de palés',
              },
              {
                Id: 12063,
                Id_Tareas: 4541,
                Codigo: '9909',
                Nombre: 'Modificar Pesaje de palés',
              },
              {
                Id: 12064,
                Id_Tareas: 4541,
                Codigo: '9910',
                Nombre: 'Eliminar Pesaje de palés',
              },
              {
                Id: 12065,
                Id_Tareas: 4541,
                Codigo: '9911',
                Nombre: 'Crear Pesaje de palés',
              },
            ],
            Formulario: '/production/traceability/palletizing/FrmWeighingSystem',
            Ensamblado: '',
          },
        ],
      },
      {
        Id: 9586,
        Id_ModuloRaiz: 7529,
        Nombre: 'Producción Individual',
        FechaActivacion: '2023-05-11T00:00:00',
        FechaDesactivacion: '1900-01-01T00:00:00',
        SubModulos: [],
        Procesos: [
          {
            Id: 9724,
            Id_Modulo: 9586,
            Id_Tareas: 4431,
            Nombre: 'Recuento de cajas por trabajador',
            Operaciones: [
              {
                Id: 11629,
                Id_Tareas: 4431,
                Codigo: '9503',
                Nombre: 'Consultar Recuento de cajas por trabajador',
              },
              {
                Id: 11630,
                Id_Tareas: 4431,
                Codigo: '9504',
                Nombre: 'Modificar Recuento de cajas por trabajador',
              },
              {
                Id: 11631,
                Id_Tareas: 4431,
                Codigo: '9505',
                Nombre: 'Eliminar Recuento de cajas por trabajador',
              },
              {
                Id: 11632,
                Id_Tareas: 4431,
                Codigo: '9506',
                Nombre: 'Crear Recuento de cajas por trabajador',
              },
            ],
            Formulario: '/production/individualProduction/countBoxPerWorker/FrmCountBoxPerWorkerHome',
            Ensamblado: '',
          },
          {
            Id: 9728,
            Id_Modulo: 9586,
            Id_Tareas: 4433,
            Nombre: 'Registro de cajas',
            Operaciones: [
              {
                Id: 11633,
                Id_Tareas: 4433,
                Codigo: '9507',
                Nombre: 'Consultar Registro de cajas',
              },
              {
                Id: 11634,
                Id_Tareas: 4433,
                Codigo: '9508',
                Nombre: 'Modificar Registro de cajas',
              },
              {
                Id: 11635,
                Id_Tareas: 4433,
                Codigo: '9509',
                Nombre: 'Eliminar Registro de cajas',
              },
              {
                Id: 11636,
                Id_Tareas: 4433,
                Codigo: '9510',
                Nombre: 'Crear Registro de cajas',
              },
            ],
            Formulario: '/production/individualProduction/palletizingWithBoxReadings/FrmBoxReadingsPalletizing',
            Ensamblado: '',
          },
        ],
      },
    ],
    Procesos: [
      {
        Id: 6622,
        Id_Modulo: 7529,
        Id_Tareas: 4403,
        Nombre: 'Ubicaciones',
        Operaciones: [
          {
            Id: 11534,
            Id_Tareas: 4403,
            Codigo: '9408',
            Nombre: 'Crear Ubicaciones',
          },
          {
            Id: 11531,
            Id_Tareas: 4403,
            Codigo: '9405',
            Nombre: 'Consultar Ubicaciones',
          },
          {
            Id: 11532,
            Id_Tareas: 4403,
            Codigo: '9406',
            Nombre: 'Modificar Ubicaciones',
          },
          {
            Id: 11533,
            Id_Tareas: 4403,
            Codigo: '9407',
            Nombre: 'Eliminar Ubicaciones',
          },
        ],
        Formulario: '/production/traceability/locationControl/FrmLocationControlHome',
        Ensamblado: '',
      },
      {
        Id: 6624,
        Id_Modulo: 7529,
        Id_Tareas: 4404,
        Nombre: 'Volcado',
        Operaciones: [
          {
            Id: 11535,
            Id_Tareas: 4404,
            Codigo: '9409',
            Nombre: 'Consultar Volcado',
          },
          {
            Id: 11536,
            Id_Tareas: 4404,
            Codigo: '9410',
            Nombre: 'Modificar Volcado',
          },
          {
            Id: 11537,
            Id_Tareas: 4404,
            Codigo: '9411',
            Nombre: 'Eliminar Volcado',
          },
          {
            Id: 11538,
            Id_Tareas: 4404,
            Codigo: '9412',
            Nombre: 'Crear Volcado',
          },
        ],
        Formulario: '/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseLogisticUnitHome',
        Ensamblado: '',
      },
      {
        Id: 6625,
        Id_Modulo: 7529,
        Id_Tareas: 4405,
        Nombre: 'Gestionar líneas de producción',
        Operaciones: [
          {
            Id: 11542,
            Id_Tareas: 4405,
            Codigo: '9416',
            Nombre: 'Crear Gestionar líneas de producción',
          },
          {
            Id: 11539,
            Id_Tareas: 4405,
            Codigo: '9413',
            Nombre: 'Consultar Gestionar líneas de producción',
          },
          {
            Id: 11540,
            Id_Tareas: 4405,
            Codigo: '9414',
            Nombre: 'Modificar Gestionar líneas de producción',
          },
          {
            Id: 11541,
            Id_Tareas: 4405,
            Codigo: '9415',
            Nombre: 'Eliminar Gestionar líneas de producción',
          },
        ],
        Formulario: '/production/traceability/manageProductionLines/FrmManageProductionLines',
        Ensamblado: '',
      },
      {
        Id: 6627,
        Id_Modulo: 7529,
        Id_Tareas: 4407,
        Nombre: 'Estado de pedidos en producción',
        Operaciones: [
          {
            Id: 11547,
            Id_Tareas: 4407,
            Codigo: '9421',
            Nombre: 'Consultar Estado de pedidos en producción',
          },
          {
            Id: 11548,
            Id_Tareas: 4407,
            Codigo: '9422',
            Nombre: 'Modificar Estado de pedidos en producción',
          },
          {
            Id: 11549,
            Id_Tareas: 4407,
            Codigo: '9423',
            Nombre: 'Eliminar Estado de pedidos en producción',
          },
          {
            Id: 11550,
            Id_Tareas: 4407,
            Codigo: '9424',
            Nombre: 'Crear Estado de pedidos en producción',
          },
        ],
        Formulario: '/production/roductionLines/productionLinesManagement/FrmProductionPlanningStatus',
        Ensamblado: '',
      },
      {
        Id: 7634,
        Id_Modulo: 7529,
        Id_Tareas: 4415,
        Nombre: 'Registro de Kilos',
        Operaciones: [
          {
            Id: 11581,
            Id_Tareas: 4415,
            Codigo: '9455',
            Nombre: 'Eliminar Registro de Kilos',
          },
          {
            Id: 11582,
            Id_Tareas: 4415,
            Codigo: '9456',
            Nombre: 'Crear Registro de Kilos',
          },
          {
            Id: 11579,
            Id_Tareas: 4415,
            Codigo: '9453',
            Nombre: 'Consultar Registro de Kilos',
          },
          {
            Id: 11580,
            Id_Tareas: 4415,
            Codigo: '9454',
            Nombre: 'Modificar Registro de Kilos',
          },
        ],
        Formulario: '/production/traceability/frmKiloRecord',
        Ensamblado: '',
      },
      {
        Id: 9671,
        Id_Modulo: 7529,
        Id_Tareas: 4422,
        Nombre: 'Gestionar Salidas de Producción',
        Operaciones: [
          {
            Id: 11605,
            Id_Tareas: 4422,
            Codigo: '9479',
            Nombre: 'Modificar Gestionar Salidas de Producción',
          },
          {
            Id: 11606,
            Id_Tareas: 4422,
            Codigo: '9480',
            Nombre: 'Eliminar Gestionar Salidas de Producción',
          },
          {
            Id: 11607,
            Id_Tareas: 4422,
            Codigo: '9481',
            Nombre: 'Crear Gestionar Salidas de Producción',
          },
          {
            Id: 11604,
            Id_Tareas: 4422,
            Codigo: '9478',
            Nombre: 'Consultar Gestionar Salidas de Producción',
          },
        ],
        Formulario: '/production/traceability/manageProductionOutputs/FrmManageProductionOutputs',
        Ensamblado: '',
      },
      {
        Id: 9672,
        Id_Modulo: 9586,
        Id_Tareas: 4434,
        Nombre: 'Planificador de producción',
        Operaciones: [],
        Formulario: '/production/productionPlanner',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 7541,
    Id_ModuloRaiz: 0,
    Nombre: 'Control de Presencia',
    FechaActivacion: '2022-05-30T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [
      {
        Id: 7542,
        Id_ModuloRaiz: 7541,
        Nombre: 'Gestión de marcajes',
        FechaActivacion: '2022-05-30T00:00:00',
        FechaDesactivacion: '1900-01-01T00:00:00',
        SubModulos: [],
        Procesos: [
          {
            Id: 6601,
            Id_Modulo: 7542,
            Id_Tareas: 4409,
            Nombre: 'Consulta marcajes',
            Operaciones: [
              {
                Id: 11557,
                Id_Tareas: 4409,
                Codigo: '9431',
                Nombre: 'Eliminar Consulta marcajes',
              },
              {
                Id: 11558,
                Id_Tareas: 4409,
                Codigo: '9432',
                Nombre: 'Crear Consulta marcajes',
              },
              {
                Id: 11556,
                Id_Tareas: 4409,
                Codigo: '9430',
                Nombre: 'Modificar Consulta marcajes',
              },
            ],
            Formulario: '/presence/workerRecords/workerRecords',
            Ensamblado: '',
          },
          {
            Id: 6619,
            Id_Modulo: 7542,
            Id_Tareas: 4410,
            Nombre: 'Marcajes masivos',
            Operaciones: [
              {
                Id: 11559,
                Id_Tareas: 4410,
                Codigo: '9433',
                Nombre: 'Consultar Marcajes masivos',
              },
              {
                Id: 11560,
                Id_Tareas: 4410,
                Codigo: '9434',
                Nombre: 'Modificar Marcajes masivos',
              },
              {
                Id: 11561,
                Id_Tareas: 4410,
                Codigo: '9435',
                Nombre: 'Eliminar Marcajes masivos',
              },
              {
                Id: 11562,
                Id_Tareas: 4410,
                Codigo: '9436',
                Nombre: 'Crear Marcajes masivos',
              },
            ],
            Formulario: '/presence/workerRecords/newMassiveRecords',
            Ensamblado: '',
          },
        ],
      },
    ],
    Procesos: [],
  },
  {
    Id: 7546,
    Id_ModuloRaiz: 0,
    Nombre: 'Control de Actividades',
    FechaActivacion: '2022-07-21T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 6618,
        Id_Modulo: 7546,
        Id_Tareas: 4411,
        Nombre: 'Actividades dispositivos',
        Operaciones: [
          {
            Id: 11563,
            Id_Tareas: 4411,
            Codigo: '9437',
            Nombre: 'Consultar Actividades dispositivos',
          },
          {
            Id: 11564,
            Id_Tareas: 4411,
            Codigo: '9438',
            Nombre: 'Modificar Actividades dispositivos',
          },
          {
            Id: 11565,
            Id_Tareas: 4411,
            Codigo: '9439',
            Nombre: 'Eliminar Actividades dispositivos',
          },
          {
            Id: 11566,
            Id_Tareas: 4411,
            Codigo: '9440',
            Nombre: 'Crear Actividades dispositivos',
          },
        ],
        Formulario: '/production/accessDevice/accessDeviceActivity',
        Ensamblado: '',
      },
      {
        Id: 6620,
        Id_Modulo: 7546,
        Id_Tareas: 4412,
        Nombre: 'Actividades trabajadores',
        Operaciones: [
          {
            Id: 11567,
            Id_Tareas: 4412,
            Codigo: '9441',
            Nombre: 'Consultar Actividades trabajadores',
          },
          {
            Id: 11568,
            Id_Tareas: 4412,
            Codigo: '9442',
            Nombre: 'Modificar Actividades trabajadores',
          },
          {
            Id: 11569,
            Id_Tareas: 4412,
            Codigo: '9443',
            Nombre: 'Eliminar Actividades trabajadores',
          },
          {
            Id: 11570,
            Id_Tareas: 4412,
            Codigo: '9444',
            Nombre: 'Crear Actividades trabajadores',
          },
        ],
        Formulario: '/production/workerRecords/workersActivity',
        Ensamblado: '',
      },
      {
        Id: 6621,
        Id_Modulo: 7546,
        Id_Tareas: 4413,
        Nombre: 'Actividades productivas en línea',
        Operaciones: [
          {
            Id: 11571,
            Id_Tareas: 4413,
            Codigo: '9445',
            Nombre: 'Consultar Actividades productivas en línea',
          },
          {
            Id: 11572,
            Id_Tareas: 4413,
            Codigo: '9446',
            Nombre: 'Modificar Actividades productivas en línea',
          },
          {
            Id: 11573,
            Id_Tareas: 4413,
            Codigo: '9447',
            Nombre: 'Eliminar Actividades productivas en línea',
          },
          {
            Id: 11574,
            Id_Tareas: 4413,
            Codigo: '9448',
            Nombre: 'Crear Actividades productivas en línea',
          },
        ],
        Formulario: '/production/productionLines/productiveActivityLine',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 7548,
    Id_ModuloRaiz: 0,
    Nombre: 'Comercializadora',
    FechaActivacion: '2022-07-21T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 6623,
        Id_Modulo: 7548,
        Id_Tareas: 4414,
        Nombre: 'Expediciones',
        Operaciones: [
          {
            Id: 11575,
            Id_Tareas: 4414,
            Codigo: '9449',
            Nombre: 'Consultar Expediciones',
          },
          {
            Id: 11576,
            Id_Tareas: 4414,
            Codigo: '9450',
            Nombre: 'Modificar Expediciones',
          },
          {
            Id: 11577,
            Id_Tareas: 4414,
            Codigo: '9451',
            Nombre: 'Eliminar Expediciones',
          },
          {
            Id: 11578,
            Id_Tareas: 4414,
            Codigo: '9452',
            Nombre: 'Crear Expediciones',
          },
        ],
        Formulario: 'commercialisation/expedition/frmExpedition',
        Ensamblado: '',
      },
      {
        Id: 9667,
        Id_Modulo: 7548,
        Id_Tareas: 4420,
        Nombre: 'Contratos de compra',
        Operaciones: [
          {
            Id: 11596,
            Id_Tareas: 4420,
            Codigo: '9470',
            Nombre: 'Consultar Contratos de compra',
          },
          {
            Id: 11597,
            Id_Tareas: 4420,
            Codigo: '9471',
            Nombre: 'Modificar Contratos de compra',
          },
          {
            Id: 11598,
            Id_Tareas: 4420,
            Codigo: '9472',
            Nombre: 'Eliminar Contratos de compra',
          },
          {
            Id: 11599,
            Id_Tareas: 4420,
            Codigo: '9473',
            Nombre: 'Crear Contratos de compra',
          },
        ],
        Formulario: 'commercialisation/contracts/frmContracts',
        Ensamblado: '',
      },
      {
        Id: 9668,
        Id_Modulo: 7548,
        Id_Tareas: 4421,
        Nombre: 'Pedidos de venta',
        Operaciones: [
          {
            Id: 11600,
            Id_Tareas: 4421,
            Codigo: '9474',
            Nombre: 'Consultar Pedidos de venta',
          },
          {
            Id: 11601,
            Id_Tareas: 4421,
            Codigo: '9475',
            Nombre: 'Modificar Pedidos de venta',
          },
          {
            Id: 11602,
            Id_Tareas: 4421,
            Codigo: '9476',
            Nombre: 'Eliminar Pedidos de venta',
          },
          {
            Id: 11603,
            Id_Tareas: 4421,
            Codigo: '9477',
            Nombre: 'Crear Pedidos de venta',
          },
        ],
        Formulario: 'commercialisation/salesOrder/frmSalesOrder',
        Ensamblado: '',
      },
      {
        Id: 10900,
        Id_Modulo: 7548,
        Id_Tareas: 4702,
        Nombre: 'Gestion de retornables',
        Operaciones: [
          {
            Id: 12441,
            Id_Tareas: 4702,
            Codigo: '10268',
            Nombre: 'Consultar Gestion de retornables',
          },
          {
            Id: 12442,
            Id_Tareas: 4702,
            Codigo: '10269',
            Nombre: 'Modificar Gestion de retornables',
          },
          {
            Id: 12443,
            Id_Tareas: 4702,
            Codigo: '10270',
            Nombre: 'Eliminar Gestion de retornables',
          },
          {
            Id: 12444,
            Id_Tareas: 4702,
            Codigo: '10271',
            Nombre: 'Crear Gestion de retornables',
          },
        ],
        Formulario: '/commercialisation/returnableManagement/frmReturnableManagement',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 8551,
    Id_ModuloRaiz: 0,
    Nombre: 'Reparaciones',
    FechaActivacion: '2022-08-04T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 7637,
        Id_Modulo: 8551,
        Id_Tareas: 4417,
        Nombre: 'Intervenciones en Partes de Reparación',
        Operaciones: [
          {
            Id: 11587,
            Id_Tareas: 4417,
            Codigo: '9461',
            Nombre: 'Consultar Partes de Reparación',
          },
          {
            Id: 11588,
            Id_Tareas: 4417,
            Codigo: '9462',
            Nombre: 'Modificar Partes de Reparación',
          },
          {
            Id: 11589,
            Id_Tareas: 4417,
            Codigo: '9463',
            Nombre: 'Eliminar Partes de Reparación',
          },
          {
            Id: 11590,
            Id_Tareas: 4417,
            Codigo: '9464',
            Nombre: 'Crear Partes de Reparación',
          },
        ],
        Formulario: '/repairs/repairsInterventions',
        Ensamblado: '',
      },
      {
        Id: 9749,
        Id_Modulo: 8551,
        Id_Tareas: 4520,
        Nombre: 'Partes de Reparación',
        Operaciones: [
          {
            Id_Tareas: 4520,
            Codigo: '9824',
            Nombre: 'Consultar Partes de Reparación',
            Id: 11978,
            Version: 0,
          },
          {
            Id_Tareas: 4520,
            Codigo: '9825',
            Nombre: 'Modificar Partes de Reparación',
            Id: 11979,
            Version: 0,
          },
          {
            Id_Tareas: 4520,
            Codigo: '9826',
            Nombre: 'Eliminar Partes de Reparación',
            Id: 11980,
            Version: 0,
          },
          {
            Id_Tareas: 4520,
            Codigo: '9827',
            Nombre: 'Crear Partes de Reparación',
            Id: 11981,
            Version: 0,
          },
        ],
        Formulario: '/repairs/repairParts',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 9570,
    Id_ModuloRaiz: 0,
    Nombre: 'Informes',
    FechaActivacion: '2022-10-31T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 9666,
        Id_Modulo: 9570,
        Id_Tareas: 4419,
        Nombre: 'Informes',
        Operaciones: [
          {
            Id: 11592,
            Id_Tareas: 4419,
            Codigo: '9466',
            Nombre: 'Consultar Informes',
          },
          {
            Id: 11593,
            Id_Tareas: 4419,
            Codigo: '9467',
            Nombre: 'Modificar Informes',
          },
          {
            Id: 11594,
            Id_Tareas: 4419,
            Codigo: '9468',
            Nombre: 'Eliminar Informes',
          },
          {
            Id: 11595,
            Id_Tareas: 4419,
            Codigo: '9469',
            Nombre: 'Crear Informes',
          },
        ],
        Formulario: 'common/reports/frmReports',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 9576,
    Id_ModuloRaiz: 0,
    Nombre: 'Almacén',
    FechaActivacion: '2023-01-17T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 9687,
        Id_Modulo: 9576,
        Id_Tareas: 4427,
        Nombre: 'Gestionar ubicación compras',
        Operaciones: [
          {
            Id: 11618,
            Id_Tareas: 4427,
            Codigo: '9492',
            Nombre: 'Eliminar Gestionar ubicación compras',
          },
          {
            Id: 11619,
            Id_Tareas: 4427,
            Codigo: '9493',
            Nombre: 'Crear Gestionar ubicación compras',
          },
          {
            Id: 11616,
            Id_Tareas: 4427,
            Codigo: '9490',
            Nombre: 'Consultar Gestionar ubicación compras',
          },
          {
            Id: 11617,
            Id_Tareas: 4427,
            Codigo: '9491',
            Nombre: 'Modificar Gestionar ubicación compras',
          },
        ],
        Formulario: '/warehouse/manageShoppingLocation/frmManageShoppingLocation',
        Ensamblado: '',
      },
      {
        Id: 9688,
        Id_Modulo: 9576,
        Id_Tareas: 4428,
        Nombre: 'Gestionar ubicación ventas',
        Operaciones: [
          {
            Id: 11621,
            Id_Tareas: 4428,
            Codigo: '9495',
            Nombre: 'Modificar Gestionar ubicación ventas',
          },
          {
            Id: 11622,
            Id_Tareas: 4428,
            Codigo: '9496',
            Nombre: 'Eliminar Gestionar ubicación ventas',
          },
          {
            Id: 11623,
            Id_Tareas: 4428,
            Codigo: '9497',
            Nombre: 'Crear Gestionar ubicación ventas',
          },
          {
            Id: 11620,
            Id_Tareas: 4428,
            Codigo: '9494',
            Nombre: 'Consultar Gestionar ubicación ventas',
          },
        ],
        Formulario: '/warehouse/manageSalesLocation/frmManageSalesLocation',
        Ensamblado: '',
      },
      {
        Id: 9689,
        Id_Modulo: 9576,
        Id_Tareas: 4429,
        Nombre: 'Recuento y regularización de inventario',
        Operaciones: [
          {
            Id: 11624,
            Id_Tareas: 4429,
            Codigo: '9498',
            Nombre: 'Consultar Recuento y regularización de inventario',
          },
          {
            Id: 11625,
            Id_Tareas: 4429,
            Codigo: '9499',
            Nombre: 'Modificar Recuento y regularización de inventario',
          },
          {
            Id: 11626,
            Id_Tareas: 4429,
            Codigo: '9500',
            Nombre: 'Eliminar Recuento y regularización de inventario',
          },
          {
            Id: 11627,
            Id_Tareas: 4429,
            Codigo: '9501',
            Nombre: 'Crear Recuento y regularización de inventario',
          },
        ],
        Formulario: '/warehouse/inventoryRegularization/frmInventoryRegularization',
        Ensamblado: '',
      },
      {
        Id: 10901,
        Id_Modulo: 9576,
        Id_Tareas: 4745,
        Nombre: 'Gestionar ubicación de articulos',
        Operaciones: [
          {
            Id: 12540,
            Id_Tareas: 4745,
            Codigo: '10367',
            Nombre: 'Eliminar Gestionar ubicación de articulos',
          },
          {
            Id: 12539,
            Id_Tareas: 4745,
            Codigo: '10366',
            Nombre: 'Modificar Gestionar ubicación de articulos',
          },
          {
            Id: 12541,
            Id_Tareas: 4745,
            Codigo: '10368',
            Nombre: 'Crear Gestionar ubicación de articulos',
          },
          {
            Id: 12538,
            Id_Tareas: 4745,
            Codigo: '10365',
            Nombre: 'Consultar Gestionar ubicación de articulos',
          },
        ],
        Formulario: '/warehouse/manageItemLocation/frmManageItemLocation',
        Ensamblado: '',
      },
    ],
  },
  {
    Id: 9632,
    Id_ModuloRaiz: 0,
    Nombre: 'Alhóndigas',
    FechaActivacion: '2024-07-25T00:00:00',
    FechaDesactivacion: '1900-01-01T00:00:00',
    SubModulos: [],
    Procesos: [
      {
        Id: 10886,
        Id_Modulo: 9632,
        Id_Tareas: 4549,
        Nombre: 'Gestión de subasta',
        Operaciones: [
          {
            Id_Tareas: 4549,
            Codigo: '9942',
            Nombre: 'Consultar Gestión de subasta',
            Estado: 0,
            Id: 12096,
            Version: 0,
          },
          {
            Id_Tareas: 4549,
            Codigo: '9943',
            Nombre: 'Modificar Gestión de subasta',
            Estado: 0,
            Id: 12097,
            Version: 0,
          },
          {
            Id_Tareas: 4549,
            Codigo: '9944',
            Nombre: 'Eliminar Gestión de subasta',
            Estado: 0,
            Id: 12098,
            Version: 0,
          },
          {
            Id_Tareas: 4549,
            Codigo: '9945',
            Nombre: 'Crear Gestión de subasta',
            Estado: 0,
            Id: 12099,
            Version: 0,
          },
        ],
        Formulario: '/alhondiga/auctions/frmAuctions',
        Ensamblado: '',
      },
    ],
  },
]);
